import apiClient from '../apiClient';
import type { User } from '@/types/user';

export default {
    /**
     * Returns the list of active users for the current account.
     */
    getAccountUsers: async (): Promise<User[]> => {
        return apiClient.get('/account/users');
    }
};
